import JsonHelper from '@/helpers/jsonHelper';
import { mapGetters, mapMutations } from 'vuex';

export default {
	async mounted() {
		if (this.init !== undefined && !this.getInited) {
			this.setInited(await this.init());
		}
	},
	computed: {
		...mapGetters('contracting', ['getSelectedOffer', 'getCheckboxData', 'getFormData', 'getInited']),
		...mapGetters(['getCalculation']),
		fields() {
			const helperClass = new JsonHelper(this.insurer, this.type);
			return helperClass.getDataForFormElements();
		},
	},
	methods: {
		...mapMutations('contracting', ['setFormData', 'setInited']),
	},
};
